import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RaGridModule } from './ra-grid/ra-grid.module';
import { RaGridComponent } from './ra-grid/ra-grid.component';
import { RaCreateComponent } from './ra-create/ra-create.component';
import { RaCreateModule } from './ra-create/ra-create.module';
import { CanDeactivateGuard } from '../../core'
import { AddEditCustomerGuard } from '../../admin/accounts/manage-customers/add-edit-customer/add-edit-customer.guard'
import { ReviewerModule } from '../../common/component/reviewer/reviewer.module';
import { ReviewerComponent } from '../../common/component/reviewer/reviewer.component';

export const routes: Routes = [
    //{ path: 'rateAudit', pathMatch: 'prefix', redirectTo: 'monitor' },
    { path: 'monitor', component: RaGridComponent },
    { path: 'create', component: RaCreateComponent, canDeactivate: [AddEditCustomerGuard] , data: {QuickAudit:false} },
    { path: 'quickcreate', component: RaCreateComponent, canDeactivate: [AddEditCustomerGuard], data: {QuickAudit:true}  },
    { path: 'review', component: ReviewerComponent, canDeactivate: [AddEditCustomerGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)
    ,RaGridModule
    ,RaCreateModule
    ,ReviewerModule
  ],
  exports: [RouterModule, RaGridModule ,ReviewerModule
  ]
})
export class RateAuditRoutingModule { }
